import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M4.821 4.212A2 2 0 0 1 6.66 3h18.682a2 2 0 0 1 1.838 1.212l2.143 5A2 2 0 0 1 27.484 12H27v9a2 2 0 0 1-2 2v2a1 1 0 1 1-2 0v-2h-2v2a1 1 0 1 1-2 0v-2H7a2 2 0 0 1-2-2v-9h-.483a2 2 0 0 1-1.839-2.788l2.143-5ZM10 16a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h-5v-5Z" clip-rule="evenodd"></path><path d="M9 24a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H9Z"></path><path d="M7 28a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z"></path></g>';
export var ManufacturedSVG = function ManufacturedSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ManufacturedSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ManufacturedSVG);